module.exports = ElcRuntime.React;